<template>
    <div class="d-flex flex-column w-100">
        <b-form-input
            v-if="withSearch"
            v-model="searchInput"
            class="pr-1 mb-1 w-100 h-25 position-sticky top"
            @change="handleSearch"
            style="z-index: 9000"
            placeholder="搜索">
        </b-form-input>
        <b-list-group v-if="dataList.length > 0">
            <b-list-group-item v-for="(item,index) of visibleList"
                               :key="index" button
                               @click="rowClick(item)">
                <div class="d-flex flex-row">
                    {{ item[labelName] }}
                    <i v-if="enableCancel" class="fa-solid fa-xmark cancel-icon-size ml-auto" @click="$emit('rowCancel',item)"></i>
                </div>
            </b-list-group-item>
        </b-list-group>
        <empty-list-info v-if="visibleList.length === 0"></empty-list-info>
    </div>
</template>

<script>
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo";

export default {
    name: "SimpleListGroup",
    components: {EmptyListInfo},
    props: {
        dataList: {
            type: Array,
            default: () => []
        },
        labelName: {
            type: String,
            default: 'value'
        },
        withSearch: {
            type: Boolean,
            default: false
        },
        enableCancel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchInput: '',
            visibleList: []
        }
    },
    mounted() {
        this.visibleList = this.dataList;
    },
    methods: {
        rowClick(row) {
            this.$emit('rowClick', row);
        },
        handleSearch() {
            let reg = new RegExp(".*" + this.searchInput + ".*", "i");
            let tempList = [];
            for (let item of this.dataList) {
                if (reg.test(item[this.labelName])) {
                    tempList.push(item);
                }
            }
            this.visibleList = tempList;
        },
    }
}
</script>

<style scoped>
.cancel-icon-size{
    font-size: 15px;
}
</style>